<script setup lang="ts">

</script>

<template>
    <ULink to="/">
        <NuxtImg src="/images/logo-light.svg" alt="Logo" class="hidden lg:block h-auto w-full max-w-[106px] lg:max-w-[200px]"/>
        <NuxtImg src="/images/logo-light-mobile.svg" alt="Logo" class="lg:hidden h-auto w-full max-w-[67px] lg:max-w-[200px]"/>
    </ULink>
</template>

<style scoped>

</style>
